import React, { useEffect, useState } from 'react'

const CuotasFormaPago = ({ total, metodoPago, paqueteId, cuotas, actualizarCuotas }) => {
    const [cuotasLocal, setCuotasLocal] = useState([])
    const forma_pago_detalle = metodoPago?.forma_pago_detalle || []
    // ✅ Evita el bucle: solo actualiza si las cuotas son diferentes
    useEffect(() => {
        if (forma_pago_detalle.length > 0) {

            const nuevasCuotas = forma_pago_detalle.map((detalle) => ({
                id: detalle.id,
                numero_cuota: detalle.numero_cuota,
                monto: ((total * detalle.porcentaje) / 100).toFixed(2),
                paquete_id: paqueteId,
            }))

            // ❗ Solo actualiza si el estado realmente cambió
            if (JSON.stringify(nuevasCuotas) !== JSON.stringify(cuotasLocal)) {
                setCuotasLocal(nuevasCuotas)
            }
        } else if (cuotasLocal.length > 0) {
            setCuotasLocal([]) // Limpia solo si antes tenía datos
        }
    }, [total, forma_pago_detalle, paqueteId])

    // ✅ Evita el bucle verificando si ya están actualizadas antes de llamar a actualizarCuotas
    useEffect(() => {
        if (cuotasLocal.length > 0 && JSON.stringify(cuotasLocal) !== JSON.stringify(cuotas)) {
            actualizarCuotas(paqueteId, cuotasLocal)
        }
    }, [cuotasLocal, cuotas, paqueteId, actualizarCuotas])

    if (!metodoPago) {
        return (
            <div className="p-4 bg-[#dbeafe] shadow-sm max-w-2xl mx-auto">
                <p className="text-md text-red-600 text-center mb-2">Selecciona una forma de pago</p>
            </div>
        )
    }

    return (
        <div className="p-2 bg-[#dbeafe] shadow-md rounded-lg max-w-3xl mx-auto">
            <p className="text-xl font-semibold text-center text-gray-800 mb-4">FORMA DE PAGO</p>
            <div className="space-y-2">
                {cuotasLocal.map((detalle) => (
                    <div key={detalle.id} className="p-2 bg-white shadow-lg rounded-md flex justify-between items-center">
                        <div className="w-full flex items-center justify-between">
                            <p className="text-md font-medium text-gray-900">Cuota #{detalle.numero_cuota} </p>
                            <span className="font-bold text-sm text-blue-500">S/. {detalle.monto}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CuotasFormaPago
